import { render } from "./DetailEvent.vue?vue&type=template&id=6e94a9f4&scoped=true"
import script from "./DetailEvent.vue?vue&type=script&lang=js"
export * from "./DetailEvent.vue?vue&type=script&lang=js"

import "./DetailEvent.vue?vue&type=style&index=0&id=6e94a9f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e94a9f4"]])

export default __exports__